import React from "react";
import { GroupProps } from "./GroupProps";
import FilterGroup from "./FilterGroup";

const SpecificationFilter = ({
  groups,
  toggleCollapsed,
  groupsWithMultipleSelections,
  prefetch,
  pageUrl,
}: GroupProps) => {
  return (
    <>
      {groups.map((group) => (
        <FilterGroup
          key={`specFilter-${group.groupNameEncoded}`}
          group={group}
          toggleCollapsed={toggleCollapsed}
          useGroupNameInUrl
          groupsWithMultipleSelections={groupsWithMultipleSelections}
          data-testid="SpecificationFilter"
          prefetch={prefetch}
          pageUrl={pageUrl}
        />
      ))}
    </>
  );
};

export default SpecificationFilter;
